import * as React from 'react'

import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import MenuItem from '@mui/material/MenuItem'
import { useTheme } from '@mui/material/styles'
import { Select } from '@workwave-tidal/core/components'

import { ProgressWidget } from '@user/components/Opportunities/AddOpportunityPage/AddOpportunityForm/FormComponents/OpportunityStageMeter/ProgressWidget/ProgressWidget'

import { useData } from './hooks/useData'
import { getOptionsStyles } from './styling'

interface Props {
  isTidalThemeActive: boolean
}

/**
 * Renders the preview examples illustrating a field's display options.
 *
 * Presentational: the active theme arrives as a prop so the component does not
 * read from the store, and its theme-dependent indent comes from
 * `getOptionsStyles`.
 */
export function SettingCardExamples(props: Props) {
  const { isTidalThemeActive } = props
  const { colors, isTidalEnabled, items } = useData(isTidalThemeActive)
  const theme = useTheme()
  const styles = getOptionsStyles(theme, isTidalThemeActive)

  return (
    <Stack
      p={2}
      sx={{
        ...styles.examplesRow,
        borderTop: '1px solid',
        borderTopColor: theme.palette.grey[300],
        backgroundColor: theme.palette.background.default,
      }}
    >
      <Typography
        variant="subtitle1"
        color={theme.palette.text.primary}
        letterSpacing={0.15}
        mb={1}
      >
        Stage meter example
      </Typography>

      <ProgressWidget
        colors={colors}
        disabled={false}
        height={32}
        onActiveIndexChange={() => {}}
        segmentMinWidth={220}
        segmentSpacing={6}
        transitionTime={0.5}
        items={items}
        onChange={() => {}}
        isTidalEnabled={isTidalEnabled}
      />

      <Typography
        variant="subtitle1"
        color={theme.palette.text.primary}
        letterSpacing={0.15}
        mb={1}
        mt={4}
      >
        Drop down example
      </Typography>

      <Select
        getLabel={(option) => option?.text}
        required
        items={items}
        value={items[0]}
        label={'Opportunity Stage'}
        optionMode={'custom'}
        renderOption={(props, stage) => {
          return (
            <MenuItem {...props} key={stage.id} value={stage.id}>
              {stage.text}
            </MenuItem>
          )
        }}
      />
    </Stack>
  )
}
SettingCardExamples.displayName = 'SettingCardExamples'
